import type { OrderedChemical } from './types';

const groupChemicalsByOrder = (
    orderedChemicals: OrderedChemical[]
): Map<number, OrderedChemical[]> => {
    const groups = new Map<number, OrderedChemical[]>();

    orderedChemicals.forEach(item => {
        const existing = groups.get(item.effectiveOrder) ?? [];

        existing.push(item);
        groups.set(item.effectiveOrder, existing);
    });

    return groups;
};

export default groupChemicalsByOrder;
